'use client';

import Image from 'next/image';
import { ReactNode, useLayoutEffect, useState } from 'react';
import LoadingGif from '@/assets/img/L1_loader.gif';

export default function GlobalLoadingOverlay({ children }: { children?: ReactNode }) {
  const [show, setShow] = useState(true);

  useLayoutEffect(() => {
    setShow(false);
  }, []);

  if (!show) {
    return null;
  }

  return (
    <div
      id="global-loading-overlay"
      className="global-loading-overlay"
    >
      <Image
        src={LoadingGif}
        width={500}
        height={500}
        alt="Loading Animation"
        className="global-loading-overlay-image"
      />
      {children}
    </div>
  );
}
